import { withAuthorization } from '@ff-os/pdp-shared-redux/apis/authorization/withAuthorization';
import { PdpState, PdpStore } from '@ff-os/pdp-shared-redux/store';
import { createAuthorizationHeader } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { prepareArPreview } from './prepareArPreview';

export const createQrArPreview = async (store: PdpStore) => {

    const state = store.getState();
    const { model, placementMode } = await exportPreview(state);
    const language = state.global.language;

    const response = await withAuthorization(async (state: PdpState) => {
        const body = { model, placementMode, language };
        return fetch(urls.createQrArPreview, formatRequest(body, state));
    }, store);

    if (!response.ok) {
        throw new Error(`Error creating ar preview [${response.status}]`);
    } else {
        return await response.json() as CreateQrArPreviewResult;
    }
};

type CreateQrArPreviewResult = {
    previewUrl: string;
    expiresOn: number;
};

const formatRequest = (upload: { model: any; placementMode: string; language: string }, state: PdpState) => {

    const formData = new FormData();
    formData.append('file', new Blob([JSON.stringify(upload.model)], { type: 'application/json' }));
    formData.append('placementMode', upload.placementMode);
    formData.append('language', upload.language);

    return {
        method: 'POST',
        headers: createAuthorizationHeader(state.auth.jwt!),
        body: formData
    };
};

const exportPreview = async (state: PdpState) => {

    const { preview, preview3d, gltf, arConfig } = await prepareArPreview(state);

    return {
        model: await preview3d.exportPreviewedEmbeddedGltf(gltf, preview, arConfig),
        placementMode: arConfig.placementMode
    };
};